import {NgModule} from '@angular/core';
import {IonicModule} from 'ionic-angular';
import {QuillModule} from 'ngx-quill';
import {HeadingQuillToolbarButtonModule} from './buttons/heading-quill-toolbar-button/heading-quill-toolbar-button.component.module';
import {ImageQuillToolbarButtonModule} from './buttons/image-quill-toolbar-button/image-quill-toolbar-button.component.module';
import {RedoQuillToolbarButtonModule} from './buttons/redo-quill-toolbar-button/redo-quill-toolbar-button.component.module';
import {UndoQuillToolbarButtonModule} from './buttons/undo-quill-toolbar-button/undo-quill-toolbar-button.component.module';
import {QuillToolbarComponent} from './quill-toolbar.component';

/**
 * Module for the quill toolbar
 */
@NgModule({
  declarations: [QuillToolbarComponent],
  exports: [QuillToolbarComponent],
  imports: [
    IonicModule,
    QuillModule,
    RedoQuillToolbarButtonModule,
    UndoQuillToolbarButtonModule,
    HeadingQuillToolbarButtonModule,
    ImageQuillToolbarButtonModule,
  ],
  providers: [],
})
export class QuillToolbarModule {
}



// WEBPACK FOOTER //
// ./src/app/content/shared/components/inputs/body/quill-toolbar/quill-toolbar.module.ts